export default function Loading() {
  return (
    <div className="center">
      <div className="loader"></div>
    </div>
  );
}
